import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

// 26BET design-kit IconButton: standardizes icon-only buttons (refresh,
// eye/eye-off, star, trash, ...) to one size/style set — see checklist item
// "IconButton: standardize icon-only buttons to one size/style set".
const iconButtonVariants = cva(
  "inline-flex items-center justify-center !rounded-[var(--radius-control)] !border !border-transparent text-[var(--text-secondary)] transition-colors disabled:pointer-events-none disabled:opacity-40 [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      size: {
        sm: "size-7 [&_svg]:size-3.5",
        md: "size-9 [&_svg]:size-4",
        lg: "size-11 [&_svg]:size-5",
      },
      variant: {
        default: "hover:bg-[var(--surface-3)] hover:text-[var(--text-primary)]",
        solid: "!border-[var(--border-subtle)] bg-[var(--surface-3)] hover:bg-[var(--bet-mobile-track)]",
        brand: "text-[var(--gold-400)] hover:bg-[var(--gold-a12)] hover:text-[var(--gold-300)]",
      },
      round: {
        true: "!rounded-full",
        false: "",
      },
    },
    defaultVariants: {
      size: "md",
      variant: "default",
      round: false,
    },
  }
)

function IconButton({
  className,
  size,
  variant,
  round,
  icon: Icon,
  label,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof iconButtonVariants> & {
    icon: React.ComponentType<{ className?: string }>
    label: string
  }) {
  return (
    <button
      type="button"
      data-slot="icon-button"
      aria-label={label}
      title={label}
      className={cn(iconButtonVariants({ size, variant, round }), className)}
      {...props}
    >
      <Icon />
    </button>
  )
}

export { IconButton, iconButtonVariants }
